module.exports = __webpack_public_path__ + "static/img/trainingVideos.8a1332fb.svg";